var __jsx = React.createElement;
import React, { useCallback } from 'react';
import { Map as MapComponent } from '@vis.gl/react-google-maps';
import styled from 'styled-components';
import styles from './Map.style.js';
import { ClusteredLocationMarkers } from './ClusteredLocationMarkers';
function Map(_ref) {
  var className = _ref.className,
    locations = _ref.locations,
    mapId = _ref.mapId,
    isLoadingInfoWindow = _ref.isLoadingInfoWindow,
    selectedLocation = _ref.selectedLocation,
    handleSelectLocation = _ref.handleSelectLocation,
    defaultMap = _ref.defaultMap,
    onResetMap = _ref.onResetMap,
    reStartMap = _ref.reStartMap,
    selectedLocationKey = _ref.selectedLocationKey,
    setSelectedLocationKey = _ref.setSelectedLocationKey,
    toggleMap = _ref.toggleMap,
    setToggleMap = _ref.setToggleMap;
  return __jsx("div", {
    className: "nva-map ".concat(className)
  }, __jsx(MapComponent, {
    mapId: mapId,
    defaultCenter: defaultMap.CENTER,
    defaultZoom: defaultMap.ZOOM,
    gestureHandling: "cooperative",
    disableDefaultUI: true,
    zoomControl: true,
    streetViewControl: true
  }, locations && __jsx(ClusteredLocationMarkers, {
    locations: locations,
    isLoadingInfoWindow: isLoadingInfoWindow,
    handleSelectLocation: handleSelectLocation,
    selectedLocationKey: selectedLocationKey,
    setSelectedLocationKey: setSelectedLocationKey,
    onResetMap: onResetMap,
    reStartMap: reStartMap,
    hasOldIcons: true,
    toggleMap: toggleMap,
    setToggleMap: setToggleMap
  }, __jsx(ClusteredLocationMarkers.OldInfoWindow, {
    selectedLocation: selectedLocation,
    toggleMap: toggleMap,
    setToggleMap: setToggleMap
  }))));
}
export default styled( /*#__PURE__*/React.memo(Map)).withConfig({
  componentId: "sc-1ns5p3y-0"
})(["", ";"], styles);